import { AppThunkAction } from '../reducers';

// Actions
import * as Actions from '../actions';

// Services
import * as service from '../../services/ProtocolVisit.Services';

// Models
import { ErrorType } from '../../models/HttpError';
import { IConsumptionsFilters } from '../../models/Filters/ConsumptionsFilters';

type KnownAction =
    | Actions.ProtocolVisits.ProtocolVisitsExportExcelRequestAction
    | Actions.ProtocolVisits.ProtocolVisitsExportExcelSuccessAction
    | Actions.ProtocolVisits.ProtocolVisitsExportExcelFailureAction;

export const ActionCreators = {
    ExportProtocolVisitsToExcel: (
        filters: IConsumptionsFilters
    ): AppThunkAction<KnownAction> => {
        return async (dispatch, getState) => {
            const state = getState();
            let token: string;

            if (state.oidc?.user?.access_token === undefined) {
                dispatch({
                    type: 'PROTOCOLVISITS_EXPORT_EXCEL_FAILURE',
                    error: {
                        ErrorCode: 401,
                        ErrorMessage: 'Not authorized',
                        Errors: []
                    }
                });
                return;
            } else {
                token = state.oidc.user.access_token;
            }

            dispatch({
                type: 'PROTOCOLVISITS_EXPORT_EXCEL_REQUEST',
                filters: filters
            });

            service.ExportAllProtocolVisits(filters, token)
                .then((excelBlob: Blob) => {
                    dispatch({
                        type: 'PROTOCOLVISITS_EXPORT_EXCEL_SUCCESS',
                        excelBlob: excelBlob
                    });
                })
                .catch((error: ErrorType) =>
                    dispatch({
                        type: 'PROTOCOLVISITS_EXPORT_EXCEL_FAILURE',
                        error: error
                    })
                );
        };
    }
};
